<boi-contextual-help-container
  [ngClass]="{ 'has-errors': hasError }"
  [contextualHelpName]="contextualHelpName !== undefined ? contextualHelpName : labelName"
>
  <boi-validation-error
    [ngClass]="{ 'd-none': !hasError }"
    (errorChange)="hasError = $event"
    [propertyNames]="propertyNames"
  ></boi-validation-error>

  <kendo-textbox-container class="form-element app">
    <div class="form-label app" [boiRequiredFormField]="labelName" [forceRequired]="forceRequired">
      <label [for]="controlId ? controlId : labelName" [innerHtml]="labelName | localizeLabel"></label>
    </div>
    <div class="form-input-container">
      <input
        [id]="controlId ? controlId : labelName"
        [(ngModel)]="value"
        [boiOnlyDigits]="digitsOnly"
        (ngModelChange)="valueChange.emit(value)"
        (blur)="valueChange.emit(ensureTrimmedValue(value)); blurChange.emit(value)"
        [autocomplete]="'off'"
        [maxlength]="fieldMaxLength"
        [disabled]="isFieldDisabled"
        [readonly]="isReadonly"
        kendoTextBox
      />
    </div>
    <ng-content></ng-content>
    <boi-tooltip [tooltipName]="tooltipName ? tooltipName : labelName"></boi-tooltip>
  </kendo-textbox-container>
</boi-contextual-help-container>
